(() => {
  if (window.ggvLandingInitialized) return;
  window.ggvLandingInitialized = true;
  const initialize = (root = document) => {
    root.querySelectorAll('[data-ggv-product-section]').forEach(marker => {
      const section = document.getElementById(`MainProduct-${marker.dataset.ggvProductSection}`);
      section?.classList.add('ggv-main');
      document.querySelectorAll('.ggv-landing a[href="#MainProduct-main"]').forEach(link => { link.href = `#${section.id}`; });
    });
    root.querySelectorAll('.ggv-landing').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      section.querySelectorAll('.seo-block').forEach(block => {
        const toggle = block.querySelector('.seo-toggle');
        if (!toggle) return;
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.addEventListener('click', () => {
          const expanded = block.classList.toggle('seo-open');
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
        });
      });
      const track = section.querySelector('.pdd-track, .seo-inner');
      if (track) {
        const previous = section.querySelector('.pdd-arrow.prev, .seo-arrow.prev');
        const next = section.querySelector('.pdd-arrow.next, .seo-arrow.next');
        const refresh = () => {
          if (previous) { previous.hidden = track.scrollLeft <= 2; previous.disabled = previous.hidden; }
          if (next) { next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; next.disabled = next.hidden; }
        };
        previous?.addEventListener('click', () => track.scrollBy({left:-track.clientWidth * .8,behavior:'smooth'}));
        next?.addEventListener('click', () => track.scrollBy({left:track.clientWidth * .8,behavior:'smooth'}));
        track.addEventListener('scroll', refresh, {passive:true});
        new ResizeObserver(refresh).observe(track);
        refresh();
      }
      const reviews = [...section.querySelectorAll('[data-review]')];
      if (reviews.length) {
        let visibleCount = 10;
        const filter = section.querySelector('[data-review-filter]');
        const more = section.querySelector('[data-load-more]');
        const show = () => {
          const matching = reviews.filter(r => !filter.value || r.dataset.rating === filter.value);
          reviews.forEach(r => { r.hidden = true; });
          matching.slice(0, visibleCount).forEach(r => { r.hidden = false; });
          more.hidden = matching.length <= visibleCount;
          const count = section.querySelector('[data-review-count]');
          if (count) count.textContent = String(matching.length);
        };
        filter.addEventListener('change', () => { visibleCount = 10; show(); });
        more.addEventListener('click', () => { visibleCount += 10; show(); });
        show();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
